<div (mouseenter)="toggleSidebar(true)" (mouseleave)="toggleSidebar(false)"
  [ngClass]="{ 'w-[10%]': isExpanded, 'w-[5%]': !isExpanded }"
  class="z-50 py-[1rem] h-screen bg-color_box text-white flex flex-col transition-width duration-300 fixed">

  <nav class="flex flex-col h-full">

    <!-- HEADER (fijo) -->
    <div class="px-2 pb-2">
      <ul>
        <li *ngIf="showRolEps"
          class="w-[80%] paintcontainer rounded transition-all duration-300 mx-auto relative cursor-pointer"
          [attr.title]="!isExpanded ? name : null">
          <div class="flex flex-col items-center justify-center cursor-pointer"
            [ngClass]="{'justify-center': !isExpanded, '': isExpanded}">
            <span class="h-[26px]">
              <mat-icon translate="no" aria-hidden="false" fontIcon="account_circle"
                class="w-[34px] h-[34px] text-color_text_box "></mat-icon>
            </span>
            <p *ngIf="isExpanded" class="text-color_text_box font-poppins text-center text-[13px]">
              {{ name }}
            </p>
          </div>
        </li>
      </ul>
    </div>

    <!-- ZONA SCROLLABLE -->
    <div class="flex-1 min-h-0 overflow-y-auto overflow-x-hidden sidebar-scroll">
      <ul class="flex flex-col px-2 py-1 space-y-2 gap-6">
        <li *ngFor="let item of navItems"
        [matTooltip]="!item.subMenu ? item.label : null"
    matTooltipPosition="above"
          class="w-[80%] paintcontainer rounded transition-all duration-300 mt-[0.5rem] mb-[0.5rem] mx-auto relative cursor-pointer"
          (mouseenter)="openSubmenu($event, item)" (mouseleave)="startCloseSubmenuTimer()"
          [attr.title]="!isExpanded ? item.label : null" (click)="navigateTo(item)">
          <div class="flex flex-col items-center justify-center cursor-pointer"
            [ngClass]="{'justify-center': !isExpanded, '': isExpanded}">
            <span *ngIf="item.label != 'Preguntas Frecuentes'">
              <img [src]="item.currentImgSrc"
                [ngClass]="(item.moduleKey === 'Dashboard' || item.moduleKey === 'Dashboard_EPS') ? 'w-[22px]' : 'w-[24px]'"
                [alt]="item.label" class="text-black border-black mx-auto">
            </span>

            <span *ngIf="item.label == 'Preguntas Frecuentes'">
              <mat-icon translate="no" aria-hidden="false" fontIcon="help" class=" text-color_text_box"></mat-icon>
            </span>
          </div>

          <div *ngIf="item.showSubmenu && item.subMenu" class="submenu fixed z-50 -top-9 left-full">
            <p *ngIf="isExpanded" class="text-color_text_box font-bold font-poppins text-[14px]">
              {{ item.label }}
            </p>
            <ul>
              <li *ngFor="let sub of item.subMenu"
                class="p-2 pl-2 text-[12px] hover:bg-gray-700 bg-[#23476b] cursor-pointer floating-submenu"
                (click)="navigateTo(sub); $event.stopPropagation()">
                {{ sub.label }}
              </li>
            </ul>
          </div>

          <div
            class="fixed z-50 -top-2 left-full bg-[#23476b] text-white text-[12px] px-2 py-1 rounded shadow-lg whitespace-nowrap">
            {{ item.label }}
          </div>
        </li>
      </ul>
    </div>



    <!-- FOOTER (fijo) -->
    <div class="px-2 pb-3 pt-2">
      <ul>
        <li
          class="w-[80%] paintcontainer rounded transition-all duration-300 mx-auto relative cursor-pointer"
          [attr.title]="!isExpanded ? name : null">
          <div (click)="exit()" class="flex flex-col items-center justify-center cursor-pointer"
            [ngClass]="{'justify-center': !isExpanded, '': isExpanded}">
            <mat-icon translate="no" aria-hidden="false" fontIcon="logout" class="text-color_text_box"></mat-icon>
          </div>
        </li>
      </ul>
    </div>

  </nav>
</div>


<!-- <div
  (mouseenter)="toggleSidebar(true)"
  (mouseleave)="toggleSidebar(false)"
  [ngClass]="{ 'w-[220px]': isExpanded, 'w-[72px]': !isExpanded }"
  class="fixed left-0 top-0 z-50 h-screen bg-color_box text-white flex flex-col transition-[width] duration-300"
>
  <header class="flex-shrink-0 px-3 pb-2">
    <div class="flex items-center gap-2">
      <mat-icon fontIcon="account_circle" class="w-[32px] h-[32px] text-color_text_box"></mat-icon>
      <div *ngIf="isExpanded" class="min-w-0 leading-tight">
        <p class="text-color_text_box font-semibold text-[13px] whitespace-nowrap truncate">{{ name }}</p>
        <p class="text-[11px] opacity-80 whitespace-nowrap truncate">Productos</p>
      </div>
    </div>
  </header>

  <main class="flex-1 min-h-0">
    <ul class="flex flex-col h-full overflow-y-auto overflow-x-hidden px-2 pt-2 pb-3 space-y-5">
      <li *ngFor="let item of navItems"
          class="paintcontainer rounded transition-all duration-300 mx-auto relative cursor-pointer w-[85%]"
          (mouseenter)="onMouseEnter(item)" (mouseleave)="onMouseLeave(item)"
          [attr.title]="!isExpanded ? item.label : null"
          (click)="navigateTo(item)"
          cdkOverlayOrigin #trigger="cdkOverlayOrigin">
        <div class="flex flex-col items-center">
          <ng-container *ngIf="item.label !== 'Preguntas Frecuentes'; else faqIcon">
            <img [src]="item.currentImgSrc" [alt]="item.label" class="mx-auto max-w-[26px]">
          </ng-container>
          <ng-template #faqIcon>
            <mat-icon fontIcon="help" class="text-color_text_box"></mat-icon>
          </ng-template>

          <p *ngIf="isExpanded"
             class="text-color_text_box text-center font-poppins text-[11px] whitespace-nowrap truncate w-full mt-1">
            {{ item.label }}
          </p>
        </div>

        <ng-template
          cdk-connected-overlay
          [cdkConnectedOverlayOrigin]="trigger"
          [cdkConnectedOverlayOpen]="item.showSubmenu && item.subMenu?.length"
          [cdkConnectedOverlayPositions]="overlayPositions"
          [cdkConnectedOverlayHasBackdrop]="false"
          [cdkConnectedOverlayScrollStrategy]="scrollStrategy"  
          [cdkConnectedOverlayOffsetX]="8"
        >
          <div class="bg-color_box p-2 rounded shadow-lg w-56 z-[60]">
            <ul>
              <li *ngFor="let sub of item.subMenu"
                  class="p-2 text-[12px] hover:bg-gray-700 cursor-pointer"
                  (click)="navigateTo(sub); $event.stopPropagation()">
                {{ sub.label }}
              </li>
            </ul>
          </div>
        </ng-template>
      </li>
    </ul>
  </main>

  <footer class="flex-shrink-0 px-3 py-3 border-t border-white/10 relative z-[70]">
    <button (click)="exit()"
            class="w-full flex items-center justify-center gap-2">
      <mat-icon fontIcon="logout" class="text-color_text_box"></mat-icon>
      <span *ngIf="isExpanded" class="text-color_text_box text-[12px] whitespace-nowrap">Salir</span>
    </button>
  </footer>
</div> -->